import api from './api';

export const certificationsApi = {
  // Get list of available certification names
  getCertificationNames: async (): Promise<string[]> => {
    const response = await api.get('/api/certifications/list');
    return response.data;
  },
};
